import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function Anexo30Y31Ano2024Certificado() {
  return <CategoryPage category="anexo30Y31Ano2024Certificado" pageTitle="Certificado JSON 2024" />;
}

export default Anexo30Y31Ano2024Certificado;
